export const LANGUAGES = [
  { code: "en", label: "EN", name: "English" },
  { code: "nl", label: "NL", name: "Nederlands" },
  { code: "fr", label: "FR", name: "Français" },
];

export const translations = {
  en: {
    headerSubtitle: "SIM Registration",
    footer: "© 2025 Jan Mobile. All rights reserved. | Secure SIM Registration",
    languageLabel: "Language",

    paymentTitle: "Jan Mobile SIM Registration",
    paymentSubtitle: "Complete a €0.50 verification payment to continue",
    payButton: "Pay €0.50",
    processing: "Processing...",

    otpTitle: "Email Verification",
    otpSubtitle: "Enter your email to receive a verification code",
    emailLabel: "Email Address",
    emailPlaceholder: "your@email.com",
    sendCode: "Send Verification Code",
    sending: "Sending...",
    codeLabel: "Verification Code",
    codePlaceholder: "Enter 6-digit code",
    verifyEmail: "Verify Email",
    verifying: "Verifying...",

    customerTitle: "Customer Information",
    customerSubtitle: "Please provide your personal details",
    firstName: "First Name *",
    firstNamePlaceholder: "John",
    lastName: "Last Name *",
    lastNamePlaceholder: "Doe",
    street: "Street *",
    streetPlaceholder: "Main Street",
    houseNumber: "House Number (incl. Bus) *",
    zipCode: "Zip Code *",
    city: "City *",
    cityPlaceholder: "Brussels",
    back: "Back",
    next: "Next",

    simTitle: "SIM Information",
    simSubtitle: "Enter your SIM card details",
    simLabel: "SIM Number (must start with 8932, 19 digits total) *",
    pukLabel: "PUK Code (8 digits) *",
    pukPlaceholder: "Enter 8-digit PUK code",
    digits: "digits",
    uploadLabel: "Upload ID Image (JPG, PNG, or PDF) *",
    fileUploaded: "FILE UPLOADED ✓",
    clickToChange: "Click to change file",
    clickToUpload: "Click to upload",
    gdpr: "I agree to the processing of my personal data for SIM registration in accordance with GDPR regulations *",
    submit: "Submit Registration",
    submitting: "Submitting...",

    successTitle: "Registration Complete!",
    successSubtitle: "Your SIM registration has been submitted successfully.",
    whatsNext: "What's next?",
    successInfo: "We will verify and confirm your SIM card registration and status. You will be contacted within 1 to 24 hours.",
    successContact: "If you have any questions, please reach out via WhatsApp at",
    orEmail: "or email us at",
    backHome: "Back to Jan Mobile Homepage",

    errPaymentTimeout: "Payment verification timed out. Please try again.",
    okPaymentVerified: "Payment verified! Please verify your email.",
    errPaymentExpired: "Payment session expired. Please try again.",
    errPaymentVerify: "Error verifying payment. Please try again.",
    errPaymentInit: "Failed to initiate payment. Please try again.",
    errEmailRequired: "Please enter your email address",
    okCodeSent: "Verification code sent to {email}. Check your email!",
    errCodeSend: "Failed to send OTP. Please try again.",
    errCodeRequired: "Please enter the OTP code",
    okEmailVerified: "Email verified successfully!",
    errCodeInvalid: "Invalid or expired OTP. Please try again.",
    errFileType: "Invalid file type. Only JPG, PNG, and PDF are allowed.",
    errFileSize: "File size must be less than 5MB",
    okFileUploaded: "ID image uploaded successfully!",
    errFileUpload: "Failed to upload file. Please try again.",
    errName: "Please enter your full name",
    errAddress: "Please complete your address",
    errSimPrefix: "SIM number must start with 8932",
    errSimLength: "SIM number must be exactly 19 digits",
    errPuk: "PUK code must be exactly 8 digits",
    errIdRequired: "Please upload your ID image",
    errGdpr: "Please accept the GDPR consent",
    okSubmitted: "Registration submitted successfully!",
    errSubmit: "Failed to submit registration. Please try again.",
    errPaymentNotCompleted: "Payment not completed",
    errEmailNotVerified: "Email not verified",
  },

  nl: {
    headerSubtitle: "SIM Registratie",
    footer: "© 2025 Jan Mobile. Alle rechten voorbehouden. | Veilige SIM Registratie",
    languageLabel: "Taal",

    paymentTitle: "Jan Mobile SIM Registratie",
    paymentSubtitle: "Voltooi een verificatiebetaling van €0,50 om verder te gaan",
    payButton: "Betaal €0,50",
    processing: "Verwerken...",

    otpTitle: "E-mailverificatie",
    otpSubtitle: "Voer uw e-mailadres in om een verificatiecode te ontvangen",
    emailLabel: "E-mailadres",
    emailPlaceholder: "uw@email.com",
    sendCode: "Verificatiecode verzenden",
    sending: "Verzenden...",
    codeLabel: "Verificatiecode",
    codePlaceholder: "Voer de 6-cijferige code in",
    verifyEmail: "E-mail verifiëren",
    verifying: "Verifiëren...",

    customerTitle: "Klantgegevens",
    customerSubtitle: "Vul uw persoonlijke gegevens in",
    firstName: "Voornaam *",
    firstNamePlaceholder: "Jan",
    lastName: "Achternaam *",
    lastNamePlaceholder: "Janssens",
    street: "Straat *",
    streetPlaceholder: "Kerkstraat",
    houseNumber: "Huisnummer (incl. bus) *",
    zipCode: "Postcode *",
    city: "Gemeente *",
    cityPlaceholder: "Brussel",
    back: "Terug",
    next: "Volgende",

    simTitle: "SIM-gegevens",
    simSubtitle: "Voer de gegevens van uw SIM-kaart in",
    simLabel: "SIM-nummer (moet beginnen met 8932, 19 cijfers in totaal) *",
    pukLabel: "PUK-code (8 cijfers) *",
    pukPlaceholder: "Voer de 8-cijferige PUK-code in",
    digits: "cijfers",
    uploadLabel: "Upload afbeelding van uw ID (JPG, PNG of PDF) *",
    fileUploaded: "BESTAND GEÜPLOAD ✓",
    clickToChange: "Klik om het bestand te wijzigen",
    clickToUpload: "Klik om te uploaden",
    gdpr: "Ik ga akkoord met de verwerking van mijn persoonsgegevens voor SIM-registratie in overeenstemming met de GDPR-wetgeving *",
    submit: "Registratie verzenden",
    submitting: "Verzenden...",

    successTitle: "Registratie voltooid!",
    successSubtitle: "Uw SIM-registratie is succesvol verzonden.",
    whatsNext: "Wat nu?",
    successInfo: "Wij controleren en bevestigen de registratie en status van uw SIM-kaart. U wordt binnen 1 tot 24 uur gecontacteerd.",
    successContact: "Heeft u vragen? Neem contact op via WhatsApp op",
    orEmail: "of mail ons op",
    backHome: "Terug naar de Jan Mobile homepage",

    errPaymentTimeout: "Betalingsverificatie is verlopen. Probeer het opnieuw.",
    okPaymentVerified: "Betaling geverifieerd! Verifieer nu uw e-mailadres.",
    errPaymentExpired: "Betalingssessie verlopen. Probeer het opnieuw.",
    errPaymentVerify: "Fout bij het verifiëren van de betaling. Probeer het opnieuw.",
    errPaymentInit: "Betaling starten mislukt. Probeer het opnieuw.",
    errEmailRequired: "Voer uw e-mailadres in",
    okCodeSent: "Verificatiecode verzonden naar {email}. Controleer uw e-mail!",
    errCodeSend: "Verzenden van de code mislukt. Probeer het opnieuw.",
    errCodeRequired: "Voer de verificatiecode in",
    okEmailVerified: "E-mailadres succesvol geverifieerd!",
    errCodeInvalid: "Ongeldige of verlopen code. Probeer het opnieuw.",
    errFileType: "Ongeldig bestandstype. Alleen JPG, PNG en PDF zijn toegestaan.",
    errFileSize: "Het bestand mag maximaal 5 MB groot zijn",
    okFileUploaded: "ID-afbeelding succesvol geüpload!",
    errFileUpload: "Uploaden mislukt. Probeer het opnieuw.",
    errName: "Voer uw volledige naam in",
    errAddress: "Vul uw volledige adres in",
    errSimPrefix: "Het SIM-nummer moet beginnen met 8932",
    errSimLength: "Het SIM-nummer moet exact 19 cijfers bevatten",
    errPuk: "De PUK-code moet exact 8 cijfers bevatten",
    errIdRequired: "Upload een afbeelding van uw ID",
    errGdpr: "Ga akkoord met de GDPR-verklaring",
    okSubmitted: "Registratie succesvol verzonden!",
    errSubmit: "Registratie verzenden mislukt. Probeer het opnieuw.",
    errPaymentNotCompleted: "Betaling niet voltooid",
    errEmailNotVerified: "E-mailadres niet geverifieerd",
  },

  fr: {
    headerSubtitle: "Enregistrement SIM",
    footer: "© 2025 Jan Mobile. Tous droits réservés. | Enregistrement SIM sécurisé",
    languageLabel: "Langue",

    paymentTitle: "Enregistrement SIM Jan Mobile",
    paymentSubtitle: "Effectuez un paiement de vérification de 0,50 € pour continuer",
    payButton: "Payer 0,50 €",
    processing: "Traitement...",

    otpTitle: "Vérification de l'e-mail",
    otpSubtitle: "Saisissez votre e-mail pour recevoir un code de vérification",
    emailLabel: "Adresse e-mail",
    emailPlaceholder: "votre@email.com",
    sendCode: "Envoyer le code de vérification",
    sending: "Envoi...",
    codeLabel: "Code de vérification",
    codePlaceholder: "Saisissez le code à 6 chiffres",
    verifyEmail: "Vérifier l'e-mail",
    verifying: "Vérification...",

    customerTitle: "Informations client",
    customerSubtitle: "Veuillez fournir vos coordonnées personnelles",
    firstName: "Prénom *",
    firstNamePlaceholder: "Jean",
    lastName: "Nom *",
    lastNamePlaceholder: "Dupont",
    street: "Rue *",
    streetPlaceholder: "Rue de l'Église",
    houseNumber: "Numéro (incl. boîte) *",
    zipCode: "Code postal *",
    city: "Commune *",
    cityPlaceholder: "Bruxelles",
    back: "Retour",
    next: "Suivant",

    simTitle: "Informations SIM",
    simSubtitle: "Saisissez les détails de votre carte SIM",
    simLabel: "Numéro SIM (doit commencer par 8932, 19 chiffres au total) *",
    pukLabel: "Code PUK (8 chiffres) *",
    pukPlaceholder: "Saisissez le code PUK à 8 chiffres",
    digits: "chiffres",
    uploadLabel: "Téléchargez une image de votre pièce d'identité (JPG, PNG ou PDF) *",
    fileUploaded: "FICHIER TÉLÉCHARGÉ ✓",
    clickToChange: "Cliquez pour changer le fichier",
    clickToUpload: "Cliquez pour télécharger",
    gdpr: "J'accepte le traitement de mes données personnelles pour l'enregistrement SIM conformément au RGPD *",
    submit: "Envoyer l'enregistrement",
    submitting: "Envoi...",

    successTitle: "Enregistrement terminé !",
    successSubtitle: "Votre enregistrement SIM a été envoyé avec succès.",
    whatsNext: "Et ensuite ?",
    successInfo: "Nous vérifierons et confirmerons l'enregistrement et le statut de votre carte SIM. Vous serez contacté dans un délai de 1 à 24 heures.",
    successContact: "Pour toute question, contactez-nous via WhatsApp au",
    orEmail: "ou par e-mail à",
    backHome: "Retour à la page d'accueil Jan Mobile",

    errPaymentTimeout: "La vérification du paiement a expiré. Veuillez réessayer.",
    okPaymentVerified: "Paiement vérifié ! Veuillez vérifier votre e-mail.",
    errPaymentExpired: "Session de paiement expirée. Veuillez réessayer.",
    errPaymentVerify: "Erreur lors de la vérification du paiement. Veuillez réessayer.",
    errPaymentInit: "Échec du lancement du paiement. Veuillez réessayer.",
    errEmailRequired: "Veuillez saisir votre adresse e-mail",
    okCodeSent: "Code de vérification envoyé à {email}. Vérifiez votre boîte mail !",
    errCodeSend: "Échec de l'envoi du code. Veuillez réessayer.",
    errCodeRequired: "Veuillez saisir le code de vérification",
    okEmailVerified: "E-mail vérifié avec succès !",
    errCodeInvalid: "Code invalide ou expiré. Veuillez réessayer.",
    errFileType: "Type de fichier invalide. Seuls JPG, PNG et PDF sont autorisés.",
    errFileSize: "La taille du fichier doit être inférieure à 5 Mo",
    okFileUploaded: "Image de la pièce d'identité téléchargée avec succès !",
    errFileUpload: "Échec du téléchargement. Veuillez réessayer.",
    errName: "Veuillez saisir votre nom complet",
    errAddress: "Veuillez compléter votre adresse",
    errSimPrefix: "Le numéro SIM doit commencer par 8932",
    errSimLength: "Le numéro SIM doit contenir exactement 19 chiffres",
    errPuk: "Le code PUK doit contenir exactement 8 chiffres",
    errIdRequired: "Veuillez télécharger une image de votre pièce d'identité",
    errGdpr: "Veuillez accepter la déclaration RGPD",
    okSubmitted: "Enregistrement envoyé avec succès !",
    errSubmit: "Échec de l'envoi de l'enregistrement. Veuillez réessayer.",
    errPaymentNotCompleted: "Paiement non effectué",
    errEmailNotVerified: "E-mail non vérifié",
  },
};

const BACKEND_ERRORS = {
  "Payment not completed": "errPaymentNotCompleted",
  "Email not verified": "errEmailNotVerified",
  "SIM number must start with 8932": "errSimPrefix",
  "GDPR consent is required": "errGdpr",
};

export const translateBackendError = (t, detail) => {
  const key = BACKEND_ERRORS[detail];
  return key ? t[key] : t.errSubmit;
};
